<template>
  <div class="product-inline-field" :class="{ 'is-dense': dense }">
    <div class="product-inline-field__box" v-if="product.variation == 0 || mode=='order'">
      <p class="product-inline-field__label">{{ propModeTranslator[mode] }}</p>
      <div class="product-inline-field__group" dir="ltr">
        <button @click="updateQuantityPriceOffer()" class="product-inline-field__save" type="button">
          <b-icon icon="check"></b-icon>
        </button>
        <input
          dir="rtl"
          type="text"
          inputmode="numeric"
          class="product-inline-field__input"
          :value="formattedValue"
          @input="onTyped"
          @keypress.enter="updateQuantityPriceOffer()"
        >
      </div>
    </div>
    <div class="product-inline-field__range" v-if="mode=='price' && product.variation == 1">
      {{ getProductPriceRange(product) }}
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {getProductPriceRange} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'

export default {
  name: "TablePriceController",
  props: {
    product: {},
    mode: {},
    dense: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tempValue: '',
      propModeTranslator: {
        price: 'قیمت',
        quantity: 'تعداد',
        offer: 'تخفیف',
        order: 'ترتیب',
      }
    }
  },
  computed: {
    formattedValue() {
      const raw = this.digitsOnly(this.product[this.mode])
      if (raw === '') {
        return ''
      }
      return this.formatNumber(raw)
    }
  },
  methods: {
    formatNumber,
    getProductPriceRange,
    digitsOnly(value) {
      const persianMap = {'۰':'0','۱':'1','۲':'2','۳':'3','۴':'4','۵':'5','۶':'6','۷':'7','۸':'8','۹':'9'}
      return String(value == null ? '' : value)
        .replace(/[۰-۹]/g, digit => persianMap[digit])
        .replace(/[^\d]/g, '')
    },
    onTyped(event) {
      const raw = this.digitsOnly(event.target.value)
      this.product[this.mode] = raw === '' ? 0 : Number(raw)
    },
    updateQuantityPriceOffer() {

      let form = {
        product_id: this.product.id,
      }

      form['quantity'] = this.product.quantity;
      form['offer'] = this.product.offer;
      form['price'] = this.product.price;
      form['order'] = this.product.order;


      this.$store.dispatch('Product/updateQuantityPriceOffer', form)
    }
  },

}
</script>

<style scoped>
.product-inline-field__box {
  min-width: 0;
}

.product-inline-field__label {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
}

.product-inline-field__group {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  padding: 2px 8px 2px 2px;
}

.product-inline-field__input {
  flex: 1;
  min-width: 0;
  height: 28px;
  border: none;
  background: transparent;
  font-size: 12px;
  font-weight: 700;
  padding: 0 4px;
  box-shadow: none;
  text-align: left;
}

.product-inline-field__input:focus {
  outline: none;
}

.product-inline-field__save {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #1e1e1e;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  font-size: 12px;
}

.product-inline-field__range {
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}
</style>